import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		imageServe: 'http://www.centnor.com',
		routeIndex:0,
		typeName:'',
		routes:[]
	},
	getters: {
	},
	mutations: {
	},
	actions: {
	},
	modules: {
	}
})
